export default defineNuxtLink({
  componentName: 'NavNuxtLink',
  externalRelAttribute: '',
  activeClass: 'bg-fp-green-7 text-white hover:bg-fp-green-7',
  exactActiveClass: 'bg-fp-green-7 text-white hover:bg-fp-green-7',
})
